/** Keep deployed demo navigation on its shared host; standalone dev uses the public marketing site. */
export function marketingHref(path: string): string {
  return process.env.NODE_ENV === "development" ? `https://www.perceptron.inc${path}` : path;
}
